/**
 * iMessage's mark (slice 2e; Paper 60–65): its blue bubble, on Messaging's
 * rows, a Chats row and an iMessage thread's rail tile (spike S-324: one blue
 * everywhere, as Messages draws a sent bubble).
 */
import { cn } from "../lib/utils";

const BUBBLE =
  "M12 3.5c-5 0-9 3.3-9 7.4 0 2.3 1.3 4.4 3.3 5.8-.2 1.3-.8 2.5-1.8 3.3 1.9.1 3.6-.6 4.8-1.7.9.2 1.8.3 2.7.3 5 0 9-3.3 9-7.5S17 3.5 12 3.5z";

/** iMessage's blue. */
export const IMESSAGE_BLUE = "#0A84FF";
/** The pale blue an iMessage tile sits on. */
export const IMESSAGE_TINT = "#E8F1FD";

/** iMessage's bubble. `tone`: its blue, the hint grey, or the text's colour. */
export function ImessageMark({
  size = 14,
  tone = "blue",
  className,
}: {
  size?: number;
  tone?: "blue" | "hint" | "current";
  className?: string;
}) {
  const fill =
    tone === "blue" ? IMESSAGE_BLUE : tone === "hint" ? "var(--color-hint)" : "currentColor";
  return (
    <svg
      aria-hidden
      data-imessage-mark
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn("shrink-0", className)}
    >
      <path d={BUBBLE} fill={fill} />
    </svg>
  );
}
